import { atom } from "jotai";
import type { RefObject } from "react";

export const whyRegisterHomepagePositionTriggerReferenceAtom = atom<RefObject<Element> | null>(
  null,
);
